import {Icon, Text} from '#component/base';
import {InnerAccordion} from '#component/util';

import {MobileAccordionProps} from './MobileAccordion.types';

import * as css from './MobileAccordion.css';

export const MobileAccordion: React.FC<MobileAccordionProps> = ({
  children,
  trigger,
  ...otherProps
}) => (
  <InnerAccordion
    triggerClassName={css.menuItem}
    trigger={
      <>
        <Text color="inherit" variant="heading2">
          {trigger}
        </Text>

        <Icon aria-hidden className={css.triggerIcon} color="currentColor" name="CaretDown" />
      </>
    }
    {...otherProps}>
    <div className={css.menu}>{children}</div>
  </InnerAccordion>
);
